import { NgModule } from '@angular/core';
import { ActiveCallsDurationPipe } from './active-call-duration.pipe';

@NgModule({
   declarations: [ActiveCallsDurationPipe],
   exports: [ActiveCallsDurationPipe],
})
export class ActiveCallsDurationPipeModule {}
